/**
 * Items used to generate the key used for the entity-connection-state
 * key for storing entity-connection-table-state
 */
export interface EntityConnectionTableStateKeyParams {
  campaignId: string;
  entityId: string;
  entityConnectionTypeId: string;
}

export const toEntityConnectionTableKey = (
  params: EntityConnectionTableStateKeyParams
): `${string}-${string}-${string}` => `${params.entityConnectionTypeId}-${params.campaignId}-${params.entityId}`;

/**
 * Returns the key as on object
 * inverse of toEntityConnectionTableKey
 *
 * @param key keyed value
 */
export const toEntityConnectionTableKeyParams = (key: `${string}-${string}-${string}`): EntityConnectionTableStateKeyParams => {
  if (!key) {
    return null;
  }
  const [campaignId, entityId, entityConnectionTypeId] = key.split('-');

  return {
    campaignId, entityId, entityConnectionTypeId
  };
};
